import { httpClient } from "@/shared/infrastructure/http/http-client";
import type { AccountDeletionPolicy, DeleteAccountResult } from "../../domain/account-deletion";
import type { HealthSummary, ImpactFactor, UserProfile } from "../../domain/entities";
import type { UpdateUserInput, UsersRepositoryPort } from "../../application/ports/users.repository.port";

export const usersHttpRepository: UsersRepositoryPort = {
  getById(id: string): Promise<UserProfile> {
    return httpClient<UserProfile>(`/users/${id}`);
  },

  getHealthSummary(id: string): Promise<HealthSummary> {
    return httpClient<HealthSummary>(`/users/${id}/health-summary`);
  },

  getImpactFactors(id: string): Promise<ImpactFactor[]> {
    return httpClient<ImpactFactor[]>(`/users/${id}/impact-factors`);
  },

  update(id: string, input: UpdateUserInput): Promise<UserProfile> {
    return httpClient<UserProfile>(`/users/${id}`, { method: "PUT", body: input });
  },

  uploadAvatar(id: string, file: File): Promise<UserProfile> {
    const formData = new FormData();
    formData.append("file", file);
    return httpClient<UserProfile>(`/users/${id}/avatar`, { method: "POST", body: formData });
  },

  async delete(id: string, accessToken: string): Promise<DeleteAccountResult> {
    // skipAuth: o token vem do login desta mesma solicitação; quem pede a exclusão pode nem ter sessão no portal.
    const body = await httpClient<{ status: "scheduled"; scheduledFor: string } | undefined>(`/users/${id}`, {
      method: "DELETE",
      skipAuth: true,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    // 204 (sem corpo) = apagada; 202 traz { status: 'scheduled', scheduledFor }.
    return body ?? { status: "deleted" };
  },

  getDeletionPolicy(): Promise<AccountDeletionPolicy> {
    return httpClient<AccountDeletionPolicy>("/account-deletion/policy", { skipAuth: true });
  },

  cancelDeletionWithToken(token: string): Promise<void> {
    return httpClient<void>("/auth/account-deletion/cancel", { method: "POST", body: { token }, skipAuth: true });
  },
};
